<template>
	<nk-page commercialAccess="System" :policyClaims="['Accounting_Account_Select']">
		<template #badges>
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="accounting"></nk-badge-item>
				<nk-badge-item type="system" modelValue="accounting" :title="$t(`forms.Account`)"></nk-badge-item>
			</nk-badge>
		</template>
		<ag-grid :options="tableOptions" :data="filteredItems" :key="filteredItems.length" v-model="selectedItem" @row_dbClicked="rowDbClicked" @preSelectedRowData="(rowData) => selectedItem = rowData" tabindex="101" ref="table" startup class="h-100 nk-card"></ag-grid>

	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'

	const FILTERS = {
		ALL: 'all',
		LEAVES: 'leaves',
		CUSTOM: 'custom',
	}

	export default {
		name: 'account-selector',
		modal: {
			size: 'md',
			stateUID: 'account-selector',
			helpTag: 'AccountList'
		},
		props: {
			data: {},
			options: {},
		},
		data() {
			return {
				settings: {
					filterType: 'all',
					rowSelection: {
						mode: 'singleRow'
					},
				},
				selectedItem: null,
				tableOptions: {
					id: this.$options.name,
					focusAndSelect: {
						allowFocus: true
					},
					rowSelection: {
						mode: 'multiRow',
						checkboxes: true,
						headerCheckbox: true
					},
					cellSelectionAggReport: false,
					sideBar: 'none',
					enterToSelect: true,
					doubleClickedToSelect: true,
					pagination: false,
					fitToWidth: true,
					columnDefs: [
						{
							field: 'rowNumber',
							headerName: '...',
							width: 60,
							pinned: 'right',
						},
						{
							field: 'accountingCode',
							headerName: this.$t('account.selector.table.c.accountingCode'),
							// sort: 'asc',
							width: 30
						},
						{
							field: 'name',
							headerName: this.$t('account.selector.table.c.name'),
							width: 200,
						},
						{
							field: 'parent',
							headerName: this.$t('account.selector.table.c.parent'),
							contentType: 'enum',
							valueFormatter: data => {
								return data.value?.name
							},

						},


					],

				},
				selectAccountButton: {
					title: this.$t('select'),
					shortcut: $sc.find('enter-only'),
					element: () => this.$refs.table.$el,
					icon: 'check',
					isPrimary: true,
					handle: (button, page, e) => {

						if (_.isEmpty(this.selectedItem))
							return this.$toast(this.$t('document.m.select-row'))

						this.resolve(this.selectedItem)
					},
					policyClaims: 'Accounting_Account_Select',
				},
				filteredItems: []
			}
		},
		computed: {
			...mapGetters({
				account_leaves: 'accounts/leaves',
				account_all: 'accounts/all',
			}),
		},
		created() {
			this.settings = _.extend({}, this.settings, this.options)
			this.tableOptions.rowSelection = this.settings.rowSelection
			this.selectedItem = this.data
		},
		mounted() {
			this.prepareWindow(this.$t('account.selector.title'), [
				this.selectAccountButton,
			])
			this.defer(() => {
				this.loadAccountsList()
			}, 200)
		},
		methods: {
			loadAccountsList() {
				switch (this.settings.filterType) {
					case FILTERS.LEAVES:
						this.filteredItems = this.account_leaves
						break
					case FILTERS.ALL:
					default:
						this.filteredItems = this.account_all
						break
				}
			},
			setSelectedAccount(node) {
				this.selectedItem = node
			},
			changeApplied(flag) {
				this.treeChanged = flag
			},
			rowDbClicked(val) {
				if (this.grandParentType() === 'modal')
					this.resolve(val)
			},
		},
	}
</script>
<style>
	.account-select {
		overflow: hidden;
		flex: 1;
	}
</style>
